import { useShopStatusStore } from "@/abilities/shop/features/shop-core/store/shop-status.store";
import { ShopCore } from "@/abilities/shop/types/shop-core";
import { ref } from "vue";
import { createShopApolloClient } from "../../shop-core/helper/create-shop-apollo-client";
import { useSalesforceAuth } from "./use-salesforce-auth";

// Create singleton instance that persists across component lifecycles
const clientContainer = ref<ShopCore.ClientWithCache | undefined>(undefined);

export function useSalesforceClient() {
    const { getAccessToken, getJwtToken } = useSalesforceAuth();

    const isCallbackFromShop = (): boolean => {
        const params = new URLSearchParams(window.location.search);
        return params.get("status") === "success" && params.get("salesforceShopToken") !== undefined;
    };

    const getClient = async () => {
        const store = useShopStatusStore();
        const { graphUrl } = store.salesforceConfig() ?? {};

        if (!graphUrl) {
            throw new Error("Base URL is not defined");
        }

        if (!clientContainer.value) {
            clientContainer.value = createShopApolloClient(graphUrl, {
                accessToken: getAccessToken(),
                additionalHeaders: {
                    jwtToken: getJwtToken(),
                },
            });
        }

        return clientContainer.value?.client;
    };

    const resetClient = (): void => {
        clientContainer.value = undefined;
    };

    return {
        getClient,
        resetClient,
        isCallbackFromShop,
    };
}
